import { X } from '@phosphor-icons/react';
import React from 'react';
import { useScreenView } from '../../../../../../../utils/ScreenViewContext';
import { AccentButton } from '../../../../../../../shared/Buttons';

export const WithdrawalSuccess = ({ onClose }: { onClose: () => void }) => {
  const { screenView } = useScreenView();

  // Match the Withdraw card's width at every breakpoint so the swap doesn't jump.
  const cardClass =
    screenView === 'mobile'
      ? 'h-auto max-h-[90%] w-[95%] max-w-[520px] overflow-x-hidden rounded-[4px] bg-white'
      : 'h-auto max-h-[90%] w-full max-w-[520px] overflow-x-hidden rounded-[4px] bg-white';

  return (
    <div className="fixed inset-0 z-40 flex items-center justify-center bg-gray-900 bg-opacity-50">
      <div className={cardClass}>
        <div className="flex h-[56px] w-full flex-row items-center justify-between p-4 align-middle">
          <h2 className="text-[16px] font-[600] text-primary">
            Your withdrawal has been successfully initiated
          </h2>
          <X
            className="hover:cursor-pointer hover:opacity-80"
            onClick={onClose}
            weight="regular"
            size={24}
          />
        </div>

        <div className="flex h-full w-full flex-col items-center gap-6 overflow-y-auto overflow-x-hidden border-[1px] border-bordergray p-6">
          <div className="flex w-full flex-row items-center space-x-4 align-middle">
            <p>
              Please allow up to two business days for it to appear in your
              account balance and transaction history.
            </p>
          </div>
        </div>
        <div className="flex justify-end space-x-2 p-4">
          <AccentButton
            onClick={onClose}
            addClass="rounded-full hover:bg-yellow-600 w-[238px] h-[48px] disabled:opacity-50 disabled:bg-yellow-600 flex flex-row items-center justify-center"
          >
            I understand
          </AccentButton>
        </div>
      </div>
    </div>
  );
};

export default WithdrawalSuccess;
